<template>
  <div class="nport-row row-eq-height row billing-item" :class="{ 'hover': index % 2 == 0 }">
    <div class="rt-cell col-xs-2">
      <div class="text-center">
        {{ nport.location }}
      </div>
    </div>
    <div class="rt-cell col-xs-2">
      <div class="text-center">
        {{ nport.serial }}
      </div>
    </div>
    <div class="rt-cell col-xs-3">
      <div class="text-center">
        {{ nport.ipAddress }}
      </div>
    </div>
    <div class="rt-cell col-xs-1">
      <div class="text-center">
        {{ nport.port }}
      </div>
    </div>
    <div class="rt-cell col-xs-1">
      <div class="text-center">
        {{ nport.version }}
      </div>
    </div>
    <div class="rt-cell col-xs-1 no-padding">
      <div class="text-center">
        <span class="fa" :class="{
          'fa-check text-success': nport.mainNPort,
          'fa-times text-danger': !nport.mainNPort
        }"></span>
      </div>
    </div>
    <div class="rt-cell last-rt-cell col-xs-2">
      <router-link class="btn btn-default" :to="'/hardware/nports/edit/' + nport.uuid">
        <span class="fa fa-edit fa-fw"></span> Edit
      </router-link>
    </div>
  </div>
</template>

<script>
import CheckboxInput from '@/components/inputs/CheckboxInput'

export default {
  components: {
    CheckboxInput
  },
  name: 'NPort',
  props: {
    object: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  computed: {
    nport () {
      return {
        ...this.object,
        ...this.updatedNPort
      }
    }
  },
  data () {
    return {
      updatedNPort: {}
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cards/NPort.vue